import { atom } from 'jotai';
import { getCommonOptions } from '@/api/product';

export interface CommonOption {
  value: number;
  text: string;
}

export interface CommonOptions {
  userTypes: CommonOption[];
  payTypes: CommonOption[];
  productUpdateFieldTypes: CommonOption[];
}

// 创建原子状态
export const commonOptionsAtom = atom<CommonOptions>({
  userTypes: [],
  payTypes: [],
  productUpdateFieldTypes: [],
});

// 创建一个加载数据的函数
export const loadCommonOptions = async (
  set: (value: CommonOptions) => void
) => {
  try {
    const data = await getCommonOptions();
    set(data.data);
  } catch (error) {
    console.error('Failed to load common options:', error);
  }
};
